import React from 'react';
import { Div, SubText, DraftDiv } from './Notifications.styled';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import CheckCircle from 'src/assets/images/CheckCircle.svg';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { Trans, useTranslation } from 'react-i18next';
import { isMobileDevice } from 'src/utils/util';

const MessageTemplate = ({
  onClose,
  title,
  content,
  height,
  marginB,
  width,
  blocked,
  fontWeight,
  background,
  position,
  isDeliveryCheck,
  myCaseRef,
  handleNoReportUsageCancellation = () => {},
}) => {
  const { t } = useTranslation();
  const formUrl_Edit = 'https://forms.office.com/pages/responsepage.aspx?id=2zk619puXUmAAHV59W1ot64duITDlZVNuQq-ORVsfRtUMlBNTEM4NjlBVkJEM1RCMUJRVk02NEVDTSQlQCN0PWcu&route=shorturl';
  const formUrl_UnableToCancel = 'https://forms.office.com/pages/responsepage.aspx?id=2zk619puXUmAAHV59W1ot64duITDlZVNuQq-ORVsfRtUMlBNTEM4NjlBVkJEM1RCMUJRVk02NEVDTSQlQCN0PWcu';
  return (
    <Popup
      title={title}
      onClose={onClose}
      img={blocked || isDeliveryCheck || !isDeliveryCheck? '' : CheckCircle}
      impersonationBackground={background}
      titleFontWeight={fontWeight}
      id={'equity-common-messageTemplate-popup'}
    >
      <DraftDiv width={width}>
        <SubText subTextHeight={height} marginBottom={marginB}>
          {content === 'edit' ? (
            <Trans
              i18nKey="orders.deliveryCheck.content.edit"
              components={[<a href={formUrl_Edit} target="_blank" rel="noopener noreferrer" />]}
            />
          ) : content === 'noUsageToReport' ? (
            <>
              <Trans
              i18nKey="orders.deliveryCheck.content.noUsageToReport"
              components={[<a href={formUrl_UnableToCancel} target="_blank" rel="noopener noreferrer" />]}
            />
              {/* {t('orders.deliveryCheck.content.noUsageToReport')} */}
            </>
          ) : !isDeliveryCheck ? (
            <>
              {content}
              <div></div>
              <div>Order {myCaseRef}</div>
            </>
          ) : (
            content
          )}
        </SubText>
        <Div position={position}>
          {!isDeliveryCheck && !blocked && (
            <Button
              show={true}
              width={blocked || !isDeliveryCheck ? '' : '80px'}
              padding={blocked || !isDeliveryCheck ? '20px' : ''}
              margin={isMobileDevice() ? '0 15px' : ''}
              height={'38px'}
              variant={ButtonStyles?.popUpSecondary}
             // popUpSecondary={true}
              marginRight={'15px'}
              fontSize={'13px'}
              clicked={onClose}
            >
              {t('orders.deliveryCheck.noCancel')}
            </Button>
          )}
          <Button
            show={true}
            width={blocked || isDeliveryCheck || !isDeliveryCheck ? '' : '80px'}
            padding={blocked || isDeliveryCheck || !isDeliveryCheck ? '20px' : ''}
            height={'38px'}
            variant={ButtonStyles?.primary}
          //  primary={true}
            fontSize={'13px'}
            clicked={!isDeliveryCheck ? handleNoReportUsageCancellation : onClose}
          >
            {blocked || isDeliveryCheck
              ? t('ConsignmentAdd.surgery.notifications.closeWindow')
              : !isDeliveryCheck
              ? t('orders.deliveryCheck.yesCancel')
              : t('ConsignmentAdd.surgery.notifications.ok')}
          </Button>
        </Div>
      </DraftDiv>
    </Popup>
  );
};

export default MessageTemplate;
